import { render, staticRenderFns } from "./CompanyDetailsContainer.vue?vue&type=template&id=88c31964"
import script from "./CompanyDetailsContainer.vue?vue&type=script&lang=js"
export * from "./CompanyDetailsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports